 $(window).scroll(function () {
      if ($(window).width() < 1025){
        if ($(window).scrollTop() > 70) {
          $('.site-header').addClass('sticky_head');
          $('.wrapper-navigation-sticky').addClass('sticky_nav');
        }else{
          $('.site-header').removeClass('sticky_head');
          $('.wrapper-navigation-sticky').removeClass('sticky_nav');
        }
    }
});
                     
    $(document).ready(function() {
     
      var curr_url = $(location).attr('href');
      var french_url = 'https://chicsew.fr';
      if(curr_url == 'https://chicsew.com/fr/' || curr_url == 'https://chicsew.com/fr'){
        //window.location.replace(french_url);
      }
      
       $(document).on('click','.faq-list__item-question', function(e) {
					e.preventDefault();
					$(this).parent().toggleClass('is-expanded');
        			$(this).parent().find('.faq-list__item-answer').slideToggle('slow');
				});
     


var $slickElementt = $('.mobile-slider');
  var $statust = $('.pagingInfoo');  
  $slickElementt.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $statust.text(i + '/' + slick.slideCount);
});   

   if ($slickElementt.length){
    $('.mobile-slider').slick({
  dots: false,
  infinite: false,
  prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M222 350L205 367 222 384" transform="translate(-204.000000, -4159.000000) translate(0.000000, 3809.000000)"/> </g> </g> </g></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M1234 350L1217 367 1234 384" transform="translate(-1216.000000, -4159.000000) translate(0.000000, 3809.000000) translate(1225.500000, 367.000000) scale(-1, 1) translate(-1225.500000, -367.000000)"/> </g> </g> </g></svg></button>', 
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true      
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }

  ]
       
});
 }  
    
       $('.blog_mobile_slider').slick({        
         slidesToShow: 4,
          slidesToScroll: 1,
          autoplaySpeed: 1000,
            prevArrow: false,
          nextArrow: false,
         autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick"
        },
        {
            breakpoint: 767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                   
                }
        }
    ]
});

      // $('.little_more .little_more_slide').slick({        
      //    slidesToShow: 4,
      //     slidesToScroll: 1,
      //     infinite: true,    
        
      //     prevArrow:'<button class="slick-prev slick-arrow"><svg aria-hidden="true" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg></button>',
      //     nextArrow:'<button class="slick-next slick-arrow"><svg aria-hidden="true" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg></button>',
      //     responsive: [
      //       {
      //         breakpoint: 767,
      //         settings: {
      //           slidesToShow: 2.5,
      //           slidesToScroll: 1,
      //           infinite: false      
      //         }
      //       }
      //     ]
      // });


   
   
	var $slickElementb = $('.mobile-blog-slider');
  	var $statusb = $('.pagingInfo-blog');  
  	$slickElementb.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  		var i = (currentSlide ? currentSlide : 0) + 1;
  		$statusb.text(i + '/' + slick.slideCount);
	});    

      if ($slickElementb.length){
     $('.mobile-blog-slider').slick({
       dots: false,
       prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M222 350L205 367 222 384" transform="translate(-204.000000, -4159.000000) translate(0.000000, 3809.000000)"/> </g> </g> </g></svg></button>',
       nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M1234 350L1217 367 1234 384" transform="translate(-1216.000000, -4159.000000) translate(0.000000, 3809.000000) translate(1225.500000, 367.000000) scale(-1, 1) translate(-1225.500000, -367.000000)"/> </g> </g> </g></svg></button>', 
       infinite: true,
       speed: 300,
       slidesToShow: 2,
       adaptiveHeight: true
     }); 
      }
      
      var retrievedObject = btoa(JSON.stringify(localStorage.getItem('items')));
      $('#getshare_email').attr('href','mailto:?subject=Share My Wishlist&body=Hey there !! Checkout my wishlist.: https://chicsew.com/pages/wishlist-results?getdata='+retrievedObject);

$('.flag_select').on('change',function(){
        var val = $(this).val();
  		window.location.href = val;
      });
      
      });
    $('.ced-sizes .ced-size-dropdown').on('change',function(e){
      var val = $(this).val();
      if(val != '' && val != null){
        if($.cookie('size') == undefined){
          $.fancybox.open({
            src  : '#size_worning',
            opts : {
              afterShow : function( instance, current ) {
                console.info( 'done!' );
                $.cookie('size',1,{path:'/',expires: 2})
              }
            }
          });  
        }
      }
    });

$(document).ready(function() {
  var materialText = $('#collapse-tab1').find('p');
  var targetText = 'satin';
  var regex = new RegExp('(' + targetText + ')', 'gi');

  $(materialText).html(function(_, html) {
    //return html.replace(regex, '$1 <span class="des_tooltip">(what is soft satin?)</span>');
  });

  var soft_satin = $('.soft_satin_text').text();
  //$(".des_tooltip").append('<span class="TooltipText">' + soft_satin + '</span>');
});

$(document).ready(function(){
      $("body .spb-select .spb-productdescfont").find("option").click(function(){
        var a = $(this).attr("value");
        console.log("here");
      });

    });

function opentab(evt, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    }
    if (!document.getElementById("defaultOpen")) {
    }else{
    document.getElementById("defaultOpen").click();
    }



/*---------------- Change main image on Quick View ------------------*/

$('body').on('change', '#quickview-template .swatch input', function () {
    //console.log('Change detected');
    
    var inputValue = $(this).val().toLowerCase();
    //console.log('Selected Value:', inputValue);

    var foundSlide = false;

    $('#quickview-template .slider-nav li.item').each(function () {
        var altText = $(this).find('img').attr('alt');
        var slideNo = parseInt($(this).attr('data-slick-index'), 10); 
        if (slideNo < 0) {
            return true; 
        }

        if (altText) {
            altText = altText.toLowerCase();
            var altParts = altText.split('|');

            if (altParts.includes(inputValue)) {
                //console.log('Matching Slide:', slideNo);

                if (!isNaN(slideNo)) {
                    $('#quickview-template .slider-nav').slick('slickGoTo', slideNo);
                    foundSlide = true;
                    return false; 
                }
            }
        }
    });

    if (!foundSlide) {
        //console.log("No matching image found.");
    }
});

StampedFn.init({ apiKey: '053b4de3-079b-46d8-bad4-e1561b2143bb', sId: '301782' });